export const isFromCareConnect = () => {
  return window.location.search.includes('from_care_connect=true');
};
